import { useEffect, useState } from "react";

import { ChevronRightIcon } from "@chakra-ui/icons";
import {
  Box,
  Container,
  Heading,
  HStack,
  Icon,
  Image,
  List,
  ListItem,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useStore } from "../../../../Store";
import { formatDate } from "../../../../utils/formatDate";
import SearchBox from "../../../Controls/SearchBox";
import { ManagePortalData, useGetManagePortalData } from "./ManagePortalHooks";
import ManagementPortalContainer from "../ManagementPortalContainer";

export default function DashboardLanding() {
  const {
    setLoading,
    setShowPopup,
    setShowPopupError,
    setPopupErrorMessage,
    sessionDetails,
  } = useStore();
  const customerId = sessionDetails?.customerId;

  const [searchFilter, setSearchFilter] = useState<string | undefined>();

  var [consents, setConsents] = useState<ManagePortalData[]>([]);
  const GetManagePortalData = useGetManagePortalData(
    setConsents,
    HandleGetDataError,
    customerId
  );

  const filteredConsentActive = SortConsentList(
    consents,
    ["active"],
    searchFilter
  );
  const filteredConsentPending = SortConsentList(
    consents,
    ["pending"],
    searchFilter
  );
  const filteredConsentArchived = SortConsentList(
    consents,
    ["withdrawn", "expired", "revoked"],
    searchFilter
  );

  useEffect(() => {
    if (Boolean(customerId)) {
      GetManagePortalData();
    }
  }, []);

  function HandleGetDataError(message: string) {
    setLoading(false);
    setShowPopup(false);
    setShowPopupError(true);
    setPopupErrorMessage(message);
  }

  return (
    <>
      <ManagementPortalContainer>
        <Heading variant="pageHeading">Data Sharing</Heading>

        <Tabs>
          <TabList>
            <Tab>ACTIVE</Tab>
            <Tab>PENDING</Tab>
            <Tab>ARCHIVED</Tab>
          </TabList>

          <Box mx={2} my={4}>
            <Text mb={2}>Search for your banking provider</Text>
            <SearchBox
              placeholder="Enter your bank name"
              ariaLabel="Enter your bank name."
              value={searchFilter}
              onChange={setSearchFilter}
            />
          </Box>

          <TabPanels>
            <TabPanel>
              <ConsentList data={filteredConsentActive} />
            </TabPanel>
            <TabPanel>
              <ConsentList data={filteredConsentPending} />
            </TabPanel>
            <TabPanel>
              <ConsentList data={filteredConsentArchived} />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </ManagementPortalContainer>
    </>
  );
}

function ConsentList({ data }: { data: ManagePortalData[] }) {
  const navigate = useNavigate();

  return (
    <Box maxH="450px" overflowY="auto">
      <List>
        {data.map((data: ManagePortalData) => (
          <ListItem
            key={data.consentId}
            onClick={() => {
              navigate(`/DataSharingArrangement/${data.consentId}`);
            }}
            py={4}
            px={6}
            borderBottom={"1px solid rgba(0, 0, 0, 0.125)"}
            cursor="pointer"
          >
            <HStack spacing={6}>
              <Image
                maxH={"100px"}
                maxW={"100px"}
                src={data.dataHolderLogoUri}
                alt={data.dataHolderDisplayName + " Logo"}
                fallbackSrc="https://via.placeholder.com/100"
              />

              <Box flex={1}>
                <Heading fontSize="sm" mb={1}>
                  {data.dataHolderDisplayName}
                </Heading>

                <Text>
                  Consent granted: {formatDate(data.consentGrantedDate)}
                </Text>
              </Box>

              <Box>
                <Icon fontSize="2xl" as={ChevronRightIcon} />
              </Box>
            </HStack>
          </ListItem>
        ))}
      </List>
    </Box>
  );
}

export function SortConsentList(
  consents: ManagePortalData[],
  validStatuses: string[],
  searchFilter?: string
) {
  let filteredConsents = consents.filter((c: ManagePortalData) =>
    validStatuses.includes(c.status.toLowerCase())
  );

  if (Boolean(searchFilter)) {
    filteredConsents = filteredConsents.filter((c: ManagePortalData) =>
      c.dataHolderDisplayName
        .toLowerCase()
        .includes(searchFilter!.toLowerCase())
    );
  }

  filteredConsents = filteredConsents.sort(
    (a: ManagePortalData, b: ManagePortalData) =>
      a.dataHolderDisplayName.localeCompare(b.dataHolderDisplayName)
  );

  return filteredConsents;
}
